// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"notesListShowMoreButton_mulitpleDropdown__3ZVSr","button":"notesListShowMoreButton_button__fWnll"};